export const roadtrip1 = {
  data: [
    { xOffset: 0, yOffset: 4, name: "Bear", coordinates: [-75.7, 39.55] },
    { xOffset: 0, yOffset: 4, name: "Roanoke", coordinates: [-80.1, 37.2] },
    { xOffset: -20, yOffset: 4, name: "Nashville", coordinates: [-86.4, 36.3] },
    { xOffset: 0, yOffset: 4, name: "Memphis", coordinates: [-89.9, 35.1] },
    { xOffset: 0, yOffset: 4, name: "Texarkana", coordinates: [-94.1, 33.4] },
    { xOffset: 0, yOffset: 4, name: "Dallas", coordinates: [-97, 32.8] },
    { xOffset: 0, yOffset: 4, name: "Odessa", coordinates: [-102.5, 31.8] },
    { xOffset: 0, yOffset: 4, name: "Las Cruces", coordinates: [-106.8, 32.2] },
  ],
  color: '#FF5533',
  tripName: 'Roadtrip August 2020'
}

export const roadtrip2 = {
  data: [
  { xOffset: 0, yOffset: 4, name: "Albuquerque", coordinates: [-106.7, 35.1] },
  { xOffset: 0, yOffset: 4, name: "Colorado Springs", coordinates: [-104.8, 38.8] },
  // { xOffset: 0, yOffset: 4, name: "Topeka", coordinates: [-95.7, 39] },
  { xOffset: 0, yOffset: 4, name: "Kansas City", coordinates: [-94.6, 39.1] },
  { xOffset: 0, yOffset: 4, name: "St. Louis", coordinates: [-90.2, 38.6] },
  { xOffset: 0, yOffset: 4, name: "Indianapolis", coordinates: [-86.2, 39.8] },
  { xOffset: 0, yOffset: 4, name: "Columbus", coordinates: [-83, 39.96] },
  { xOffset: 0, yOffset: 4, name: "Pittsburgh", coordinates: [-80, 40.4] },
], 
  color: '#feac1c',
  tripName: 'Roadtrip May 2021'
}

export const roadtrip3 = {
  data: [
  { xOffset: 0, yOffset: 4, name: "Cleveland", coordinates: [-81.7, 41.5] },
  { xOffset: 0, yOffset: 4, name: "Chicago", coordinates: [-87.6, 41.9] },
  { xOffset: 0, yOffset: 4, name: "Des Moines", coordinates: [-93.6, 41.6] },
  { xOffset: 0, yOffset: 4, name: "Omaha", coordinates: [-96.0, 41.3] },
  { xOffset: 0, yOffset: 4, name: "Cheyenne", coordinates: [-104.8, 41.1] },
  { xOffset: 0, yOffset: 4, name: "Salt Lake City", coordinates: [-111.9, 40.8] },
  { xOffset: 0, yOffset: 4, name: "Zion", coordinates: [-113, 37.3] },
  { xOffset: 0, yOffset: 4, name: "Las Vegas", coordinates: [-115.1, 36.2] },
], 
  color: '#f6c801',
  tripName: 'Roadtrip August 2021'
}

export const roadtrip4 = {
  data: [
  { xOffset: 0, yOffset: 4, name: "Los Angeles", coordinates: [-118.2,34.1] },
  { xOffset: 0, yOffset: 4, name: "Sacramento", coordinates: [-121.5,38.6] },
  { xOffset: -5, yOffset: 4, name: "Medford", coordinates: [-122.9,42.3] },
  { xOffset: 15, yOffset: 4, name: "Crater Lake", coordinates: [-122.1,42.9] },
  { xOffset: 0, yOffset: 4, name: "Portland", coordinates: [-122.7,45.5] },
  { xOffset: -10, yOffset: 4, name: "Olympia", coordinates: [-122.9,47.03] },
  { xOffset: 12, yOffset: 4, name: "Seattle", coordinates: [-122.3,47.6] },
  { xOffset: -15, yOffset: 4, name: "Spokane", coordinates: [-117.4,47.7] },
  { xOffset: 18, yOffset: 4, name: "Tubbs Hill", coordinates: [-116.8,47.7] },
  { xOffset: 0, yOffset: 4, name: "Helena", coordinates: [-112.0,46.6] },
  { xOffset: 0, yOffset: 4, name: "Bismarck", coordinates: [-100.8,46.8] },
  { xOffset: 0, yOffset: 4, name: "Pierre", coordinates: [-100.4,44.4] },
  { xOffset: 0, yOffset: 4, name: "Sioux Falls", coordinates: [-96.7,43.5] },
  { xOffset: 0, yOffset: 4, name: "Saint Paul", coordinates: [-93.1,44.95] },
  { xOffset: -12, yOffset: 4, name: "Madison", coordinates: [-89.4,43.1] },
  { xOffset: 12, yOffset: 4, name: "Milwaukee", coordinates: [-87.9,43.03] },
  { xOffset: 0, yOffset: 4, name: "Carbondale", coordinates: [-89.2,37.7] },
  { xOffset: 0, yOffset: 4, name: "Lexington", coordinates: [-84.5,38.0] },
  { xOffset: 0, yOffset: 4, name: "Charleston", coordinates: [-81.6,38.3] },
  { xOffset: 0, yOffset: 4, name: "Washington", coordinates: [-77.0,38.9] },
], 
  color: '#30D5C8',
  tripName: 'Roadtrip May 2022'
}

export const roadtrip5 = {
  data: [
  { xOffset: 0, yOffset: 4, name: "Richmond", coordinates: [-77.4,37.5] },
  { xOffset: 0, yOffset: 4, name: "Raleigh", coordinates: [-78.6,35.8] },
  { xOffset: -5, yOffset: 4, name: "Columbia", coordinates: [-81.0,34.0] },
  { xOffset: 15, yOffset: 4, name: "Kennesaw Mountain", coordinates: [-84.6,34.0] },
  { xOffset: 0, yOffset: 4, name: "Huntsville", coordinates: [-86.6,34.7] },
  { xOffset: -10, yOffset: 4, name: "Oklahoma City", coordinates: [-97.5,35.5] },
], 
  color: '#FFFFFF',
  tripName: 'Roadtrip January 2023'
}

export const miscellaneous = {
  data: [
  { xOffset: 0, yOffset: 4, name: "Lewisburg", coordinates: [-86.4, 35.3] },
  { xOffset: 0, yOffset: 4, name: "Boston", coordinates: [-71.1, 42.4] },
  { xOffset: 0, yOffset: 4, name: "Port St. Lucie", coordinates: [-80.4, 27.3] },
  { xOffset: 0, yOffset: 4, name: "Berkeley", coordinates: [-122.3, 37.9] },
  { xOffset: 0, yOffset: -20, name: "Portland, ME", coordinates: [-70.3, 43.7] },
  { xOffset: 0, yOffset: 4, name: "Portsmouth", coordinates: [-70.8, 43.0] },
  { xOffset: 0, yOffset: 0, name: "Jackson", coordinates: [-90.2, 32.3] },
  { xOffset: 0, yOffset: 0, name: "New Orleans", coordinates: [-90.1, 30.0] },
  { xOffset: 0, yOffset: 0, name: "Phoenix", coordinates: [-112.1, 33.4] },
  { xOffset: 0, yOffset: 0, name: "Ireland", coordinates: [-7.4, 53.9] },
  { xOffset: 0, yOffset: 0, name: "Georgia", coordinates: [44.8, 41.7] },
  { xOffset: 0, yOffset: 0, name: "Germany", coordinates: [11.6, 48.1] },
  { xOffset: 0, yOffset: 0, name: "Spain", coordinates: [-0.4, 39.5] },
  { xOffset: 0, yOffset: 0, name: "Toronto", coordinates: [-79.4, 43.7] },
  { xOffset: 0, yOffset: 0, name: "Houston", coordinates: [-95.4, 29.8] },
  { xOffset: 0, yOffset: 0, name: "Miami", coordinates: [-80.2, 25.8] },
  { xOffset: 0, yOffset: 0, name: "Denver", coordinates: [-105.0, 39.7] },
  { xOffset: 0, yOffset: 4, name: "Salt Lake City", coordinates: [-111.9, 40.8] },
], 
  color: '#903cec',
  tripName: 'Miscellaneous'
}

export const asiaTrip2024 = {
  data: [
  { xOffset: 20, yOffset: 4, name: "Tokyo", coordinates: [139.7, 35.7] },
  { xOffset: -20, yOffset: 4, name: "Ho Chi Minh City", coordinates: [106.6, 10.8] },
  { xOffset: 0, yOffset: 4, name: "Quy Nhon", coordinates: [109.2, 13.8] },
  { xOffset: 0, yOffset: 0, name: "Sydney", coordinates: [151.2, -33.9] },
  { xOffset: 0, yOffset: 4, name: "Newcastle", coordinates: [151.8, -32.9] },
  { xOffset: 0, yOffset: 0, name: "Honolulu", coordinates: [-157.9, 21.3] },
], 
  color: '#CF8B43',
  tripName: 'Asia/Australia Trip 2024'
}

export const placesILived = {
  data: [
  { xOffset: 20, yOffset: 4, name: "Westhampton", coordinates: [-72.5, 40.8128] },
  { xOffset: -20, yOffset: 4, name: "New Rochelle", coordinates: [-73.8, 41] },
  { xOffset: 0, yOffset: 4, name: "Tucson", coordinates: [-111.15, 32.1] },
  { xOffset: 0, yOffset: 0, name: "Austin", coordinates: [-97.7, 30.3] },
], 
  color: '#458c99',
  tripName: 'I lived here'
}